// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import useReactRouter from 'use-react-router'

import makeStyles from '@material-ui/styles/makeStyles'

import { ucfirst } from '../fonction'
import { useGlobalState } from '../store'
import { formattedMessage } from '../CurrentLocale'

import { NAVBAR_HEIGHT } from '../global'
import type { GlobalState } from '../types/globalState'

type PropsItem = {
  title: any,
  active?: boolean,
  to: string,
  subSubMenu: Array<Object>,
  classes: Object,
}

type Props = {
  subMenu: Array<Object>,
  path: string,
}

const paddingParent = NAVBAR_HEIGHT / 3

const useStyles = makeStyles({
  root: ({ theme }) => ({
    minWidth: '200px',
    maxWidth: '20vw',
    height: '100%',
    color: theme.colors.primaryText,
    backgroundColor: '#ffffff',
  }),
  itemLink: ({ theme }) => ({
    position: 'relative',
    display: 'block',
    textDecoration: 'none',
    color: theme.colors.primaryText,
  }),
})

const Item = ({ title, active = false, to, subSubMenu = [], classes }: PropsItem) => {
  const [theme]: GlobalState = useGlobalState('theme')

  return (
    <div
      key={`div${title}`}
      style={{
        padding: paddingParent,
        minHeight: 40,
        display: 'flex',
        justifyContent: 'flex-start',
        borderBottom: `1px solid ${theme.colors.backgroundLight}`,
        cursor: 'pointer',
        flexDirection: 'column',
        textDecoration: 'none',
      }}
    >
      <Link to={to} key={title} className={classes.itemLink}>
        <div
          key={title}
          style={{
            borderLeft: `3px solid ${
              active || (subSubMenu.length > 0 && subSubMenu.filter((i) => !!i.active).length > 0)
                ? theme.colors.primaryButtonBackground
                : 'transparent'
            }`,
            paddingLeft: 16,
            display: 'flex',
            alignItems: 'center',
            height: 40,
            fontWeight: 'bold',
            width: '100%',
          }}
        >
          {title}
        </div>
      </Link>
      {subSubMenu.length > 0 &&
        subSubMenu.map((itemRoute) => {
          return (
            <Link to={itemRoute.path} className={classes.itemLink} key={itemRoute.key}>
              <div
                key={itemRoute.key}
                style={{
                  borderLeft: `3px solid ${
                    itemRoute.active ? theme.colors.primaryButtonBackground : 'transparent'
                  }`,
                  color: `${
                    itemRoute.active
                      ? theme.colors.webPrimaryTextMenu
                      : theme.colors.webNotActiveSideBarSubMenu
                  }`,
                  paddingLeft: 12,
                  marginBottom: 12,
                  marginLeft: 12,
                  fontSize: 14,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  fontWeight: 'bold',
                }}
              >
                {itemRoute.title}
              </div>
            </Link>
          )
        })}
    </div>
  )
}

const Sidebar = ({ subMenu = [], path = '' }: Props) => {
  const [theme]: GlobalState = useGlobalState('theme')
  const { history } = useReactRouter()
  const classes = useStyles({ theme })

  return (
    <div className={classes.root}>
      {subMenu.map((itemRoute) => {
        const title = formattedMessage({ id: `NavBar.${itemRoute.title}` })

        const subSubMenu = itemRoute?.subRoute?.map((itemSubRoute) => {
          const subTitle = formattedMessage({ id: `NavBar.${itemSubRoute.title}` })

          return {
            ...itemSubRoute,
            title: ucfirst(subTitle),
            onClick: () => history.push(itemSubRoute.path),
            active: path === itemSubRoute.path,
            key: itemSubRoute.title,
          }
        })

        return (
          <Item
            key={itemRoute.title}
            subSubMenu={subSubMenu}
            active={path === itemRoute.path}
            to={itemRoute.path}
            classes={classes}
            title={title}
          />
        )
      })}
    </div>
  )
}

export default Sidebar
